import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Switch,
  Radio,
  RadioGroup,
  Link,
  IconButton,
} from "@mui/material";
import { CustomButton } from "components/CustomComponents";
import { useForm } from "react-hook-form";
import { themes } from "services/constants";
import CloseIcon from "@mui/icons-material/Close";
import {
  type,
  SftPenaltyPolicyExample,
  SftPenaltyPolicySftExample,
  SftPenaltyPolicyCountExample,
  SftDeductBreakPenaltyPolicyExample,
  SftDeductSalaryForAbsenceExample,
  penaltyOptions,
  deductionOptions,
  breakOptions,
  boxStyle,
  CustomBox,
  optionsStyle,
  individualBoxStyle,
  infoMessageStyle,
  additionalInfoStyle,
  cardStyle,
  mainOptions,
} from "../Component/ShiftCategoryOptions";
import { CustomAutoComplete } from "components/CustomComponents";
import { CustomButtonWithOutLoader } from "components/CustomComponents/CustomButton";

export const Deductions = ({
  handleBack,
  onUpdate,
  handleNext,
  data,
  sftPenaltyPolicy,
  isAbsencePaid,
  setClearAbsenceValues,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    resetField,
    formState: { errors },
  } = useForm({
    defaultValues: {
      is_apply_sft_penalty_policy: false,
      penalty_options: "hours",
      dedctions_options: "Attendance",
      attendance_first_mins: 0,
      attendance_late_exit: 0,
      attendance_initial_mins: 0,
      attendance_additional_mins: 0,
      fixed_amount_early_late: 0,
      fixed_amount_deduct_amount: 0,
      fixed_amount_extra_mins: 0,
      fixed_amount_early_late_deduct_amt: 0,
      sft_penalty_early_late_mins: 0,
      sft_penalty_deduct: 0,
      sft_penalty_additional_mins: 0,
      sft_penalty_sft_deduct: 0,
      sft_penalty_count_thershold: 0,
      sft_penalty_count_deduct: 0,
      sft_penalty_count_additional_mins: 0,
      sft_penalty_count_sft_deduct: 0,
      is_apply_break_penalty_policy: false,
      is_deduct_break_penalty_policy: "always",
      extra_break_minutes: 0,
      break_deduction: 0,
      additional_break_minutes: 0,
      additional_break_deduction: 0,
      deductions_attendance_deduct_type: "",
      deductions_fixed_amount_deduct_type: "",
      break_penalty_deduct_type: "",
      deduct_salary_for_absence: false,
      deduction: 0,
      additional_deduction: 0,
      extra_deduction: 0,
      extra_additional_deduction: 0,
      trigger: true,
    },
  });
  const [absencePaid, setAbsencePaid] = useState(isAbsencePaid ?? false);
  const hanldePenaltyOptions = (event) => {
    const value = event.target.value;
    setValue("penalty_options", value);
    if (value === "hours") {
      resetSftPenalty();
      resetCountPenalty();
    } else if (value === "shift") {
      resetAttendanceSftPenalty();
      resetCountPenalty();
    } else {
      resetAttendanceSftPenalty();
      resetSftPenalty();
    }
  };

  const hanldeDeductionOptions = (event) => {
    setValue("dedctions_options", event.target.value);
    if (event.target.value === "Attendance") {
      resetFixedAmtSftPenalty();
    } else {
      resetAttendanceSftPenalty();
    }
  };

  const handleDeductBreakPenaltyPolicy = (event) => {
    setValue("is_deduct_break_penalty_policy", event.target.value);
  };

  const onSubmit = async (formValues) => {
    onUpdate({
      ...formValues,
    });
    handleNext(3);
  };

  useEffect(() => {
    if (data && Object.keys(data)?.length > 0) {
      reset(data);
    }
  }, [data, reset]);

  const resetFixedAmtSftPenalty = () => {
    const fields = [
      "fixed_amount_early_late",
      "fixed_amount_deduct_amount",
      "fixed_amount_extra_mins",
      "fixed_amount_early_late_deduct_amt",
    ];

    fields.forEach((field) => {
      resetField(field, { keepError: false });
      setValue(field, 0, { shouldValidate: false });
    });
    setValue("deductions_fixed_amount_deduct_type", "");
  };

  const resetAttendanceSftPenalty = useCallback(() => {
    const fields = [
      "attendance_first_mins",
      "attendance_late_exit",
      "attendance_initial_mins",
      "attendance_additional_mins",
    ];

    fields.forEach((field) => {
      resetField(field, { keepError: false });
      setValue(field, 0, { shouldValidate: false });
    });
    setValue("deductions_attendance_deduct_type", "");
  }, [resetField, setValue]);

  const resetSftPenalty = useCallback(() => {
    const fields = [
      "sft_penalty_early_late_mins",
      "sft_penalty_deduct",
      "sft_penalty_additional_mins",
      "sft_penalty_sft_deduct",
    ];

    fields.forEach((field) => {
      resetField(field, { keepError: false });
      setValue(field, 0, { shouldValidate: false });
    });
  }, [resetField, setValue]);

  const resetCountPenalty = useCallback(() => {
    const fields = [
      "sft_penalty_count_thershold",
      "sft_penalty_count_deduct",
      "sft_penalty_count_additional_mins",
      "sft_penalty_count_sft_deduct",
    ];

    fields.forEach((field) => {
      resetField(field, { keepError: false });
      setValue(field, 0, { shouldValidate: false });
    });
  }, [resetField, setValue]);

  useEffect(() => {
    if (sftPenaltyPolicy) {
      setValue("is_apply_sft_penalty_policy", false);
      setValue("is_apply_break_penalty_policy", false);
      setValue("penalty_options", "hours");
      setValue("dedctions_options", "Attendance");
      resetAttendanceSftPenalty();
      resetSftPenalty();
      resetCountPenalty();
      setValue("is_deduct_break_penalty_policy", "always");
      setValue("break_penalty_deduct_type", "");
      [
        "extra_break_minutes",
        "break_deduction",
        "additional_break_minutes",
        "additional_break_deduction",
      ].forEach((field) => {
        resetField(field, { keepError: false });
        setValue(field, 0, { shouldValidate: false });
      });
      // setValue("trigger", false);
    }
  }, [
    absencePaid,
    isAbsencePaid,
    resetAttendanceSftPenalty,
    resetCountPenalty,
    resetField,
    resetSftPenalty,
    setClearAbsenceValues,
    setValue,
    sftPenaltyPolicy,
    watch,
  ]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{ flexGrow: 1, overflow: "auto", p: 2 }}
        component="form"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2.5,
          }}
        >
          {!sftPenaltyPolicy && (
            <>
              <Box sx={mainOptions}>
                <Box sx={boxStyle(watch("is_apply_sft_penalty_policy"))}>
                  <Typography fontWeight="medium">
                    Apply shift penalty policy
                  </Typography>

                  <Switch
                    checked={watch("is_apply_sft_penalty_policy")}
                    onChange={(event) => {
                      const checked = event.target.checked;
                      setValue("is_apply_sft_penalty_policy", checked);
                      if (!checked) {
                        setValue("penalty_options", "hours");
                        setValue("dedctions_options", "Attendance");
                        resetAttendanceSftPenalty();
                        resetSftPenalty();
                        resetCountPenalty();
                      }
                    }}
                  />
                </Box>
                {watch("is_apply_sft_penalty_policy") && (
                  <>
                    <Box sx={{ ml: 2, mb: 2 }}>
                      <Typography fontWeight="medium">
                        Penalty based on
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Defines how penalties or adjustments are calculated.
                      </Typography>
                    </Box>

                    <Box sx={{ mb: 2 }}>
                      <RadioGroup
                        row
                        value={watch("penalty_options")}
                        onChange={hanldePenaltyOptions}
                        sx={optionsStyle}
                      >
                        {penaltyOptions.map((opt) => {
                          const isActive = watch("penalty_options") === opt.id;
                          return (
                            <Box key={opt.id} sx={cardStyle(isActive)}>
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <Radio value={opt.id} />
                                <Typography
                                  fontWeight="medium"
                                  sx={{
                                    color: isActive
                                      ? themes.stepActiveColor
                                      : "inherit",
                                  }}
                                >
                                  {opt.label}
                                </Typography>
                              </Box>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                  ml: 4,
                                  maxWidth: 250,
                                  wordBreak: "break-word",
                                }}
                              >
                                {opt.description}
                              </Typography>
                            </Box>
                          );
                        })}
                      </RadioGroup>
                    </Box>
                    {watch("penalty_options") === "hours" && (
                      <>
                        <Box sx={{ ml: 2, mb: 2 }}>
                          <Typography fontWeight="medium">
                            Deduction calculation based on
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Choose between payment factor (linked to attendance)
                            or fixed amount.
                          </Typography>
                        </Box>
                        <Box sx={{ mb: 2 }}>
                          <RadioGroup
                            row
                            value={watch("dedctions_options")}
                            onChange={hanldeDeductionOptions}
                            sx={optionsStyle}
                          >
                            {deductionOptions.map((opt) => {
                              const isActive =
                                watch("dedctions_options") === opt.id;
                              return (
                                <Box key={opt.id} sx={cardStyle(isActive)}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Radio value={opt.id} />
                                    <Typography
                                      fontWeight="medium"
                                      sx={{
                                        color: isActive
                                          ? themes.stepActiveColor
                                          : "inherit",
                                      }}
                                    >
                                      {opt.label}
                                    </Typography>
                                  </Box>
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{
                                      ml: 4,
                                      maxWidth: 250,
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {opt.description}
                                  </Typography>
                                </Box>
                              );
                            })}
                          </RadioGroup>
                        </Box>

                        {watch("dedctions_options") === "Attendance" ? (
                          <>
                            <Box sx={additionalInfoStyle}>
                              <Box sx={individualBoxStyle}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  For the first
                                </Typography>
                                <CustomBox
                                  name="attendance_first_mins"
                                  type="minutes"
                                  value={watch("attendance_first_mins")}
                                  register={register}
                                  errors={errors}
                                  handleChange={(e, value) => {
                                    setValue("attendance_first_mins", value);
                                  }}
                                  rules={{ required: "Enter value" }}
                                  inputWidth="50px"
                                />

                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  mins of late arrival or early exit,a
                                </Typography>
                                <CustomBox
                                  name="attendance_late_exit"
                                  type="minutes"
                                  value={watch("attendance_late_exit")}
                                  register={register}
                                  errors={errors}
                                  handleChange={(e, value) => {
                                    setValue("attendance_late_exit", value);
                                  }}
                                  rules={{ required: "Enter value" }}
                                  inputWidth="50px"
                                />

                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  mins deduction
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  will be applied
                                </Typography>
                                <Box
                                  sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    width: 180,
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <CustomAutoComplete
                                    dataList={type
                                      ?.filter(
                                        (obj) => obj.label !== "Individual OT"
                                      )
                                      .map((obj) => ({
                                        ...obj,
                                        label: obj.label,
                                      }))}
                                    rules={{
                                      ...register(
                                        "deductions_attendance_deduct_type",
                                        {
                                          required: false,
                                          validate: {
                                            minLengthNoSpaces: (value) => {
                                              if (
                                                watch(
                                                  "is_apply_sft_penalty_policy"
                                                ) &&
                                                watch("penalty_options") ===
                                                  "hours" &&
                                                watch("dedctions_options") ===
                                                  "Attendance" &&
                                                watch(
                                                  "deductions_attendance_deduct_type"
                                                ) === ""
                                              ) {
                                                return "Value is required";
                                              } else {
                                                return true;
                                              }
                                            },
                                          },
                                        }
                                      ),
                                    }}
                                    selectedValue={watch(
                                      "deductions_attendance_deduct_type"
                                    )}
                                    updateDataFunction={(event, data) =>
                                      setValue(
                                        "deductions_attendance_deduct_type",
                                        data?.label
                                      )
                                    }
                                    placeHolder="Select type"
                                    errorMessage={
                                      errors?.deductions_attendance_deduct_type
                                        ?.message
                                        ? errors
                                            ?.deductions_attendance_deduct_type
                                            ?.message
                                        : ""
                                    }
                                    textBoxError={
                                      errors?.deductions_attendance_deduct_type
                                        ? true
                                        : false
                                    }
                                  />
                                </Box>
                              </Box>
                            </Box>
                            <Box sx={additionalInfoStyle}>
                              <Box sx={individualBoxStyle}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  After that for every additional
                                </Typography>
                                <CustomBox
                                  name="attendance_initial_mins"
                                  type="minutes"
                                  value={watch("attendance_initial_mins")}
                                  register={register}
                                  errors={errors}
                                  handleChange={(e, value) => {
                                    setValue("attendance_initial_mins", value);
                                  }}
                                  rules={{ required: "Enter value" }}
                                  inputWidth="50px"
                                />

                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  mins of early/late, a
                                </Typography>
                                <CustomBox
                                  name="attendance_additional_mins"
                                  type="minutes"
                                  value={watch("attendance_additional_mins")}
                                  register={register}
                                  errors={errors}
                                  handleChange={(e, value) => {
                                    setValue(
                                      "attendance_additional_mins",
                                      value
                                    );
                                  }}
                                  rules={{ required: "Enter value" }}
                                  inputWidth="50px"
                                />

                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  mins
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  deduction will be applied.
                                </Typography>
                              </Box>
                            </Box>
                            <Box sx={infoMessageStyle}>
                              <SftPenaltyPolicyExample />
                            </Box>
                          </>
                        ) : (
                          <>
                            <Box sx={additionalInfoStyle}>
                              <Box sx={individualBoxStyle}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  If an employee is late arrival or early exit
                                  by
                                </Typography>
                                <CustomBox
                                  name="fixed_amount_early_late"
                                  type="minutes"
                                  value={watch("fixed_amount_early_late")}
                                  register={register}
                                  errors={errors}
                                  handleChange={(e, value) => {
                                    setValue("fixed_amount_early_late", value);
                                  }}
                                  rules={{ required: "Enter value" }}
                                  inputWidth="50px"
                                />

                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  mins
                                </Typography>
                                <CustomBox
                                  name="fixed_amount_deduct_amount"
                                  type="amount"
                                  value={watch("fixed_amount_deduct_amount")}
                                  register={register}
                                  errors={errors}
                                  handleChange={(e, value) => {
                                    setValue(
                                      "fixed_amount_deduct_amount",
                                      value
                                    );
                                  }}
                                  rules={{ required: "Enter value" }}
                                  inputWidth="50px"
                                />

                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  amount will
                                </Typography>

                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  be deducted
                                </Typography>

                                <Box
                                  sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    width: 180,
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <CustomAutoComplete
                                    dataList={type?.map((obj) => ({
                                      ...obj,
                                      label: obj?.label,
                                    }))}
                                    rules={{
                                      ...register(
                                        "deductions_fixed_amount_deduct_type",
                                        {
                                          required: false,
                                          validate: {
                                            minLengthNoSpaces: (value) => {
                                              if (
                                                watch(
                                                  "is_apply_sft_penalty_policy"
                                                ) &&
                                                watch("penalty_options") ===
                                                  "hours" &&
                                                watch("dedctions_options") ===
                                                  "Amount" &&
                                                watch(
                                                  "deductions_fixed_amount_deduct_type"
                                                ) === ""
                                              ) {
                                                return "Value is required";
                                              } else {
                                                return true;
                                              }
                                            },
                                          },
                                        }
                                      ),
                                    }}
                                    selectedValue={watch(
                                      "deductions_fixed_amount_deduct_type"
                                    )}
                                    updateDataFunction={(event, data) =>
                                      setValue(
                                        "deductions_fixed_amount_deduct_type",
                                        data?.label
                                      )
                                    }
                                    placeHolder="Select type"
                                    errorMessage={
                                      errors
                                        ?.deductions_fixed_amount_deduct_type
                                        ?.message
                                        ? errors
                                            ?.deductions_fixed_amount_deduct_type
                                            ?.message
                                        : ""
                                    }
                                    textBoxError={
                                      errors?.deductions_fixed_amount_deduct_type
                                        ? true
                                        : false
                                    }
                                  />
                                </Box>
                              </Box>
                            </Box>
                            <Box sx={additionalInfoStyle}>
                              <Box sx={individualBoxStyle}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  For every additional
                                </Typography>
                                <CustomBox
                                  name="fixed_amount_extra_mins"
                                  type="minutes"
                                  value={watch("fixed_amount_extra_mins")}
                                  register={register}
                                  errors={errors}
                                  handleChange={(e, value) => {
                                    setValue("fixed_amount_extra_mins", value);
                                  }}
                                  rules={{ required: "Enter value" }}
                                  inputWidth="50px"
                                />

                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  mins an additional
                                </Typography>
                                <CustomBox
                                  name="fixed_amount_early_late_deduct_amt"
                                  type="amount"
                                  value={watch(
                                    "fixed_amount_early_late_deduct_amt"
                                  )}
                                  register={register}
                                  errors={errors}
                                  handleChange={(e, value) => {
                                    setValue(
                                      "fixed_amount_early_late_deduct_amt",
                                      value
                                    );
                                  }}
                                  rules={{ required: "Enter value" }}
                                  inputWidth="50px"
                                />
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  will be deductable
                                </Typography>

                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {watch("deductions_fixed_amount_deduct_type")}
                                </Typography>
                              </Box>
                            </Box>
                            <Box sx={infoMessageStyle}>
                              <SftPenaltyPolicyExample />
                            </Box>
                          </>
                        )}
                      </>
                    )}

                    {watch("penalty_options") === "shift" && (
                      <>
                        <Box sx={additionalInfoStyle}>
                          <Box sx={individualBoxStyle}>
                            <Typography variant="body2" color="text.secondary">
                              If an employee is late arrival or early exit by
                            </Typography>
                            <CustomBox
                              name="sft_penalty_early_late_mins"
                              type="minutes"
                              value={watch("sft_penalty_early_late_mins")}
                              register={register}
                              errors={errors}
                              handleChange={(e, value) => {
                                setValue("sft_penalty_early_late_mins", value);
                              }}
                              rules={{ required: "Enter value" }}
                              inputWidth="50px"
                            />

                            <Typography variant="body2" color="text.secondary">
                              mins
                            </Typography>
                            <CustomBox
                              name="sft_penalty_deduct"
                              type="shift"
                              value={watch("sft_penalty_deduct")}
                              register={register}
                              errors={errors}
                              handleChange={(e, value) => {
                                setValue("sft_penalty_deduct", value);
                              }}
                              rules={{ required: "Enter value" }}
                              inputWidth="50px"
                            />

                            <Typography variant="body2" color="text.secondary">
                              shift will be deducted
                            </Typography>
                          </Box>
                        </Box>
                        <Box sx={additionalInfoStyle}>
                          <Box sx={individualBoxStyle}>
                            <Typography variant="body2" color="text.secondary">
                              For every additional
                            </Typography>
                            <CustomBox
                              name="sft_penalty_additional_mins"
                              type="minutes"
                              value={watch("sft_penalty_additional_mins")}
                              register={register}
                              errors={errors}
                              handleChange={(e, value) => {
                                setValue("sft_penalty_additional_mins", value);
                              }}
                              rules={{ required: "Enter value" }}
                              inputWidth="50px"
                            />
                            <Typography variant="body2" color="text.secondary">
                              mins, early or late, another
                            </Typography>
                            <CustomBox
                              name="sft_penalty_sft_deduct"
                              type="shift"
                              value={watch("sft_penalty_sft_deduct")}
                              register={register}
                              errors={errors}
                              handleChange={(e, value) => {
                                setValue("sft_penalty_sft_deduct", value);
                              }}
                              rules={{ required: "Enter value" }}
                              inputWidth="50px"
                            />
                            <Typography variant="body2" color="text.secondary">
                              shift will be
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              deducted
                            </Typography>
                          </Box>
                        </Box>
                        <Box sx={infoMessageStyle}>
                          <SftPenaltyPolicySftExample />
                        </Box>
                      </>
                    )}
                    {watch("penalty_options") === "count" && (
                      <>
                        <Box sx={additionalInfoStyle}>
                          <Box sx={individualBoxStyle}>
                            <Typography variant="body2" color="text.secondary">
                              If an employee breaches the late entry/early exit
                              thershold
                            </Typography>
                            <CustomBox
                              name="sft_penalty_count_thershold"
                              type="shift"
                              value={watch("sft_penalty_count_thershold")}
                              register={register}
                              errors={errors}
                              handleChange={(e, value) => {
                                setValue("sft_penalty_count_thershold", value);
                              }}
                              rules={{ required: "Enter value" }}
                              inputWidth="50px"
                            />

                            <Typography variant="body2" color="text.secondary">
                              times
                            </Typography>
                            <CustomBox
                              name="sft_penalty_count_deduct"
                              type="shift"
                              value={watch("sft_penalty_count_deduct")}
                              register={register}
                              errors={errors}
                              handleChange={(e, value) => {
                                setValue("sft_penalty_count_deduct", value);
                              }}
                              rules={{ required: "Enter value" }}
                              inputWidth="50px"
                            />

                            <Typography variant="body2" color="text.secondary">
                              shift will be deducted
                            </Typography>
                          </Box>
                        </Box>
                        <Box sx={additionalInfoStyle}>
                          <Box sx={individualBoxStyle}>
                            <Typography variant="body2" color="text.secondary">
                              For every additional breach of
                            </Typography>
                            <CustomBox
                              name="sft_penalty_count_additional_mins"
                              type="shift"
                              value={watch("sft_penalty_count_additional_mins")}
                              register={register}
                              errors={errors}
                              handleChange={(e, value) => {
                                setValue(
                                  "sft_penalty_count_additional_mins",
                                  value
                                );
                              }}
                              rules={{ required: "Enter value" }}
                              inputWidth="50px"
                            />

                            <Typography variant="body2" color="text.secondary">
                              the deduction will be
                            </Typography>
                            <CustomBox
                              name="sft_penalty_count_sft_deduct"
                              type="shift"
                              value={watch("sft_penalty_count_sft_deduct")}
                              register={register}
                              errors={errors}
                              handleChange={(e, value) => {
                                setValue("sft_penalty_count_sft_deduct", value);
                              }}
                              rules={{ required: "Enter value" }}
                              inputWidth="50px"
                            />
                            <Typography variant="body2" color="text.secondary">
                              shift
                            </Typography>
                          </Box>
                        </Box>
                        <Box sx={infoMessageStyle}>
                          <SftPenaltyPolicyCountExample />
                        </Box>
                      </>
                    )}
                  </>
                )}
              </Box>

              <Box sx={mainOptions}>
                <Box sx={boxStyle(watch("is_apply_break_penalty_policy"))}>
                  <Typography fontWeight="medium">
                    Apply break penalty policy
                  </Typography>
                  <Switch
                    checked={watch("is_apply_break_penalty_policy")}
                    onChange={(event) => {
                      const checked = event.target.checked;
                      setValue("is_apply_break_penalty_policy", checked);
                      if (!checked) {
                        setValue("is_deduct_break_penalty_policy", "always");
                        setValue("break_penalty_deduct_type", "");
                        [
                          "extra_break_minutes",
                          "break_deduction",
                          "additional_break_minutes",
                          "additional_break_deduction",
                        ].forEach((field) => {
                          resetField(field, { keepError: false });
                          setValue(field, 0, { shouldValidate: false });
                        });
                      }
                    }}
                  />
                </Box>
                {watch("is_apply_break_penalty_policy") && (
                  <>
                    <Box sx={{ ml: 2, mb: 2 }}>
                      <Box>
                        <Typography fontWeight="medium">Break</Typography>
                        <Typography variant="body2" color="text.secondary">
                          Extra breaks taken during shift time are deducted from
                          payable hours.
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ mb: 2 }}>
                      <RadioGroup
                        row
                        value={watch("is_deduct_break_penalty_policy")}
                        onChange={handleDeductBreakPenaltyPolicy}
                        sx={optionsStyle}
                      >
                        {breakOptions.map((opt) => {
                          const isActive =
                            watch("is_deduct_break_penalty_policy") === opt.id;
                          return (
                            <Box key={opt.id} sx={cardStyle(isActive)}>
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <Radio value={opt.id} />
                                <Typography
                                  fontWeight="medium"
                                  sx={{
                                    color: isActive
                                      ? themes.stepActiveColor
                                      : "inherit",
                                  }}
                                >
                                  {opt.label}
                                </Typography>
                              </Box>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                  ml: 4,
                                  maxWidth: 250,
                                  wordBreak: "break-word",
                                }}
                              >
                                {opt.description}
                              </Typography>
                            </Box>
                          );
                        })}
                      </RadioGroup>
                    </Box>
                    <Box sx={additionalInfoStyle}>
                      <Box sx={individualBoxStyle}>
                        <Typography variant="body2" color="text.secondary">
                          An extra break of up to
                        </Typography>
                        <CustomBox
                          name="extra_break_minutes"
                          type="minutes"
                          value={watch("extra_break_minutes")}
                          register={register}
                          errors={errors}
                          handleChange={(e, value) => {
                            setValue("extra_break_minutes", value);
                          }}
                          rules={{ required: "Enter value" }}
                          inputWidth="50px"
                        />

                        <Typography variant="body2" color="text.secondary">
                          minutes will result in a
                        </Typography>
                        <CustomBox
                          name="break_deduction"
                          type="minutes"
                          value={watch("break_deduction")}
                          register={register}
                          errors={errors}
                          handleChange={(e, value) => {
                            setValue("break_deduction", value);
                          }}
                          rules={{ required: "Enter value" }}
                          inputWidth="50px"
                        />

                        <Typography variant="body2" color="text.secondary">
                          minute
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          deduction
                        </Typography>
                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            width: 180,
                            verticalAlign: "middle",
                          }}
                        >
                          <CustomAutoComplete
                            dataList={type
                              ?.filter((obj) => obj.label !== "Individual OT")
                              .map((obj) => ({
                                ...obj,
                                label: obj.label,
                              }))}
                            rules={{
                              ...register("break_penalty_deduct_type", {
                                required: false,
                                validate: {
                                  minLengthNoSpaces: (value) => {
                                    if (
                                      watch("is_apply_break_penalty_policy") &&
                                      watch("break_penalty_deduct_type") === ""
                                    ) {
                                      return "Value is required";
                                    } else {
                                      return true;
                                    }
                                  },
                                },
                              }),
                            }}
                            selectedValue={watch("break_penalty_deduct_type")}
                            updateDataFunction={(event, data) =>
                              setValue("break_penalty_deduct_type", data?.label)
                            }
                            placeHolder="Select type"
                            errorMessage={
                              errors?.break_penalty_deduct_type?.message
                                ? errors?.break_penalty_deduct_type?.message
                                : ""
                            }
                            textBoxError={
                              errors?.break_penalty_deduct_type ? true : false
                            }
                          />
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={additionalInfoStyle}>
                      <Box sx={individualBoxStyle}>
                        <Typography variant="body2" color="text.secondary">
                          For every additional
                        </Typography>
                        <CustomBox
                          name="additional_break_minutes"
                          type="minutes"
                          value={watch("additional_break_minutes")}
                          register={register}
                          errors={errors}
                          handleChange={(e, value) => {
                            setValue("additional_break_minutes", value);
                          }}
                          rules={{ required: "Enter value" }}
                          inputWidth="50px"
                        />

                        <Typography variant="body2" color="text.secondary">
                          minutes beyond that, another
                        </Typography>
                        <CustomBox
                          name="additional_break_deduction"
                          type="minutes"
                          value={watch("additional_break_deduction")}
                          register={register}
                          errors={errors}
                          handleChange={(e, value) => {
                            setValue("additional_break_deduction", value);
                          }}
                          rules={{ required: "Enter value" }}
                          inputWidth="50px"
                        />

                        <Typography variant="body2" color="text.secondary">
                          {`minute deduction will be applied ${watch(
                            "break_penalty_deduct_type"
                          )}`}
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={infoMessageStyle}>
                      <SftDeductBreakPenaltyPolicyExample />
                    </Box>
                  </>
                )}
              </Box>
            </>
          )}
          <Box sx={mainOptions}>
            <Box sx={boxStyle(watch("deduct_salary_for_absence"))}>
              <Typography fontWeight="medium">
                Apply absence penalty policy
              </Typography>
              <Switch
                checked={watch("deduct_salary_for_absence")}
                onChange={(event) => {
                  const checked = event.target.checked;
                  setValue("deduct_salary_for_absence", checked);
                  if (!checked) {
                    const fields = [
                      "deduction",
                      "additional_deduction",
                      "extra_deduction",
                      "extra_additional_deduction",
                    ];

                    fields.forEach((field) => {
                      resetField(field, { keepError: false });
                      setValue(field, 0, { shouldValidate: false });
                    });
                  }
                }}
              />
            </Box>
            {watch("deduct_salary_for_absence") && absencePaid && (
              <Box
                sx={{
                  backgroundColor: "#fff6e5",
                  borderRadius: 2,
                  p: 1.5,
                  position: "relative",
                  mb: 2,
                  ml: 2,
                  mr: 2,
                  border: `1px solid ${themes.miliedLightGray}`,
                }}
              >
                <Typography variant="body2">
                  <strong>‘Absence Paid’</strong> is on.{" "}
                  <Link
                    component="button"
                    underline="hover"
                    color="success.main"
                    onClick={() => {
                      setAbsencePaid(false);
                      setClearAbsenceValues(true);
                    }}
                    sx={{ fontWeight: 500, pb: 0.5 }}
                  >
                    Click here
                  </Link>{" "}
                  to turn it off and apply the deduction.
                </Typography>

                <IconButton
                  size="small"
                  onClick={() => {
                    setAbsencePaid(false);
                  }}
                  sx={{
                    position: "absolute",
                    top: 4,
                    right: 4,
                    color: "#c62828",
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            )}
            {watch("deduct_salary_for_absence") && (
              <>
                <Box sx={{ ml: 2, mb: 2 }}>
                  <Box>
                    <Typography fontWeight="medium">
                      Apply penalty for absence
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Enable this option to deduct additional salary days for
                      each day of absence, on top of the normal deduction.
                    </Typography>
                  </Box>
                </Box>

                <Box sx={additionalInfoStyle}>
                  <Box sx={{ ...individualBoxStyle, mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      If an employee is absent for
                    </Typography>
                    <CustomBox
                      name="deduction"
                      type="shift"
                      value={watch("deduction")}
                      register={register}
                      errors={errors}
                      handleChange={(e, value) => {
                        setValue("deduction", value);
                      }}
                      rules={{ required: "Enter value" }}
                      inputWidth="50px"
                    />

                    <Typography variant="body2" color="text.secondary">
                      day deduct an additional
                    </Typography>
                    <CustomBox
                      name="additional_deduction"
                      type="shift"
                      value={watch("additional_deduction")}
                      register={register}
                      errors={errors}
                      handleChange={(e, value) => {
                        setValue("additional_deduction", value);
                      }}
                      rules={{ required: "Enter value" }}
                      inputWidth="50px"
                    />
                    <Typography variant="body2" color="text.secondary">
                      day as penalty.
                    </Typography>
                  </Box>
                </Box>
                <Box sx={additionalInfoStyle}>
                  <Box sx={individualBoxStyle}>
                    <Typography variant="body2" color="text.secondary">
                      For every extra
                    </Typography>
                    <CustomBox
                      name="extra_deduction"
                      type="shift"
                      value={watch("extra_deduction")}
                      register={register}
                      errors={errors}
                      handleChange={(e, value) => {
                        setValue("extra_deduction", value);
                      }}
                      rules={{ required: "Enter value" }}
                      inputWidth="50px"
                    />

                    <Typography variant="body2" color="text.secondary">
                      day of absence,deduct
                    </Typography>
                    <CustomBox
                      name="extra_additional_deduction"
                      type="shift"
                      value={watch("extra_additional_deduction")}
                      register={register}
                      errors={errors}
                      handleChange={(e, value) => {
                        setValue("extra_additional_deduction", value);
                      }}
                      rules={{ required: "Enter value" }}
                      inputWidth="50px"
                    />
                    <Typography variant="body2" color="text.secondary">
                      day as penalty.
                    </Typography>
                  </Box>
                </Box>
                <Box sx={infoMessageStyle}>
                  <SftDeductSalaryForAbsenceExample />
                </Box>
              </>
            )}
          </Box>
          <Box
            sx={{
              ml: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <CustomButton
                actionName="Prev"
                typeName="button"
                actionFuntion={() => {
                  handleBack(1);
                }}
              />
            </Box>
            <Box>
              {absencePaid && watch("deduct_salary_for_absence") ? (
                <CustomButtonWithOutLoader
                  actionName="Next"
                  disableAction={true}
                />
              ) : (
                <CustomButton actionName="Next" typeName="submit" />
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
